module.exports = __webpack_public_path__ + "static/img/1_3.b67d9675.jpg";